export const days = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado']
export const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
                       'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

export const noData ='Nenhuma informação para exibir'
export const noResult ='Nenhum registro encontrado'
export const rowsPerPageT = 'Linhas por página'


// WEBPACK FOOTER //
// ./src/locale/vuetify.js